// Library Imports
import React from 'react'
import { Container} from 'react-bootstrap'

// Component Imports
import LoginForm from './LoginForm'
import PageBanner from '../../components/banner/PageBanner'

function Login() {
    return (
        <>
            <div className='login-page-container'>
                <PageBanner pageName="Login" />
                <Container fluid>
                    <LoginForm />
                </Container>
            </div>
        </>
    )
}

export default Login